/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Rule_DescriptionInputs */

const en_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Choose one of four contribution plans (one-time only).
・All Forest Power will be combined. When milestones are reached, Forest will donate real trees after the event ends.
・These real trees will not count toward your personal real tree quota.`)
};

const ar_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・اختر واحدة من خطط المساهمة الأربعة (مرة واحدة فقط).
・سيتم دمج جميع قوى Forest. عند الوصول إلى المعالم، ستتبرع Forest بأشجار حقيقية بعد أسبوع من انتهاء الحدث.
・لن تُحسب هذه الأشجار الحقيقية ضمن حصتك الشخصية من الأشجار الحقيقية.`)
};

const de_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Wählen Sie einen von vier Beitragsplänen (einmalig).
・Alle Forest Power werden kombiniert. Wenn Meilensteine erreicht sind, wird Forest eine Woche nach Ende der Veranstaltung echte Bäume spenden.
・Diese echten Bäume werden nicht zu Ihrem persönlichen echten Baumkontingent gezählt.`)
};

const es_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Elige uno de los cuatro planes de contribución (sólo una vez).
・Todos los poderes de Forest se combinarán. Cuando se alcancen los hitos, Forest donará árboles reales una semana después de que finalice el evento.
・Estos árboles reales no contarán para tu cuota personal de árboles reales.`)
};

const fr_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Choisissez l'un des quatre plans de contribution (une seule fois).
・Tout le Pouvoir Forest sera combiné. Lorsque les étapes importantes seront atteintes, Forest fera don de véritables arbres une semaine après la fin de l'événement.
・Ces arbres réels ne seront pas comptabilisés dans votre quota personnel d'arbres réels.`)
};

const it_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Scegli uno dei quattro piani di contributo (una sola volta).
・Tutto il Forest Power verrà combinato. Quando raggiungi dei traguardi, Forest donerà alberi reali una settimana dopo il termine dell'evento.
・Questi alberi reali non saranno conteggiati nella tua quota personale di alberi reali.`)
};

const ja_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・4つの貢献プランから1つを選択できます（1回のみ）。
・Forestパワーはすべて合算されます。目標を達成すると、イベントが終了してから1週間後に、Forestが本物の木を寄付します。
・イベントで付与される本物の木は、個人の本物の木の数にはカウントされません。`)
};

const ko_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ 기부 기념 나무 하나를 골라요(택1).
・ Forest Power는 모두 하나로 합쳐져요. 마일스톤을 달성하면 Forest가 이벤트 종료 후 실제 나무를 기부해요.
・ 이번 이벤트의 실제 나무는 개별 사용자의 실제 나무 할당량과 별도로 기부돼요.`)
};

const pt_br_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Escolha um dos nossos planos de contribuição (única).
・Todo o Poder do Forest será combinado. Tendo os marcos sido alcançados, o Forest fará a doação de árvores reais uma semana após o encerramento do evento.
・Essas árvores reais não contabilizam na sua cota pessoal de árvores de verdade.`)
};

const ru_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Выберите один из четырёх планов вклада (только один раз).
・Вся сила Forest будет объединена. После выполнения этапов Forest пожертвует реальные деревья через неделю после окончания события.
・Эти реальные деревья не будут учитываться в вашей личной квоте на реальные деревья.`)
};

const th_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・เลือกแผนการมีส่วนร่วมแผนใดแผนหนึ่งจากสี่แผน (ครั้งเดียวเท่านั้น)
・พลังแห่ง Forest ทั้งหมดจะถูกรวมเข้าด้วยกัน เมื่อบรรลุเป้าหมาย Forest จะบริจาคต้นไม้จริงในหนึ่งสัปดาห์หลังจากที่อีเวนต์สิ้นสุดลง
・ต้นไม้จริงเหล่านี้จะไม่ถูกนับรวมในโควตาต้นไม้จริงส่วนบุคคลของคุณ`)
};

const tr_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・Dört katkı planından birini seç (yalnızca bir kez).
・Tüm Forest Gücü birleştirilecektir. Kilometre taşlarına ulaşıldığında, Forest etkinlik bittikten bir hafta sonra gerçek ağaçlar bağışlayacaktır.
・Bu gerçek ağaçlar kişisel gerçek ağaç kotana sayılmayacaktır.`)
};

const zh_cn_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・于四种方案中择一捐赠（只能捐赠一次）
・用户的森林能量共同累积，达到阶段目标后，Forest 会于活动结束后捐赠相对应的真树
・此活动的真树捐赠，不影响个人捐赠真树数量`)
};

const zh_tw_event_rule_description = /** @type {(inputs: Event_Rule_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・於四種方案中擇一捐贈（只能捐贈一次）
・用戶的森林能量共同累積，達到階段目標後，Forest 會於活動結束後捐贈相對應的真樹
・此活動的真樹捐贈，不影響個人捐贈真樹數量`)
};

/**
* | output |
* | --- |
* | "・Choose one of four contribution plans (one-time only). ・All Forest Power will be combined. When milestones are reached, Forest will donate real trees after ..." |
*
* @param {Event_Rule_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_rule_description = /** @type {((inputs?: Event_Rule_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Rule_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_rule_description(inputs)
	if (locale === "ar") return ar_event_rule_description(inputs)
	if (locale === "de") return de_event_rule_description(inputs)
	if (locale === "es") return es_event_rule_description(inputs)
	if (locale === "fr") return fr_event_rule_description(inputs)
	if (locale === "it") return it_event_rule_description(inputs)
	if (locale === "ja") return ja_event_rule_description(inputs)
	if (locale === "ko") return ko_event_rule_description(inputs)
	if (locale === "pt_br") return pt_br_event_rule_description(inputs)
	if (locale === "ru") return ru_event_rule_description(inputs)
	if (locale === "th") return th_event_rule_description(inputs)
	if (locale === "tr") return tr_event_rule_description(inputs)
	if (locale === "zh_cn") return zh_cn_event_rule_description(inputs)
	return zh_tw_event_rule_description(inputs)
});